@if (product$ | async; as product) {
<div class="col-12 pl-2">
  <ng-template [cxOutlet]="outlets.SUMMARY" [cxOutletContext]="{ product: product }">
    <div class="d-flex">
      <p [innerHTML]="product?.name" class="summary w-100 mb-2"></p>
      <button class="btn reset p-1 float-right" (click)="back()">
        <i class="fas fa-level-down-alt fa-rotate-90" aria-hidden="true"></i>
      </button>
    </div>
    <!--@if (product?.description) {
    <p [innerHTML]="product?.description" class="w-100 font-size-18 text-muted mb-3"></p>
  } -->
    @if (product?.materialOverviewText) {
    <h4 class="w-100 text-muted mb-2 description-styles">
      {{ getDisplayedMaterialOverviewText(product?.materialOverviewText) }}
    </h4>
    @if (isLongMaterialOverview(product?.materialOverviewText)) {
    <a href="#" class="read-more-link" (click)="toggleMaterialOverview($event)">
      {{ isMaterialOverviewExpanded ? 'Read less' : 'Read more' }}
    </a>
    }
    }
  </ng-template>
</div>
}
